'use strict';
angular.module("controllers").controller('appContainerCtrl',  function ($scope) {});

